import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';

import buildsReducer from './reducers';

const importBuilds = () => import(/* webpackChunkName: "builds" */ './containers/BuildContainer');

const BuildRoutes = ({ match }) => (
  <BundleRoute
    load={importBuilds}
    path={`${match.url}/:buildId/:tabName?`}
  />
);

BuildRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default dynamic(
  'apps.builds', attachReducer(buildsReducer),
)(BuildRoutes);
